import React from "react";
import MainPagePresenter from "./MainPagePresenter";
// import { Menu } from "nq-component";
import { getAllSchemasUseCase } from "../../usecases/schema/usecases";
import { getCurrentUserUseCase, signOutUseCase } from "../../usecases/user";
import { Routes, Route } from "react-router-dom";
import { OffCanvas } from "nq-component";
// import OffCanvas from "../../../src/components/OffCanvas/index";
import Menu from "../../../src/components/Menu";
import CollectionListPage from "../collection-list/CollectionListPage";
import CollectionFormPage from "../collection-form/CollectionFormPage";
import BasePage from "../../base/BasePage";
import NotFoundPage from "../notfound";
import { Layout, LogoHolder } from "nq-component";
import MigrationPage from "../migration/MigrationPage";
import AccountPage from "../account/AccountPage";
import ResetPasswordPage from "../reset-password/ResetPasswordPage";
import RoleFormPage from "../role-form/RoleFormPage";
import withRouter from "../../withRouter";
// import DashboardPage from "../DashboardMain/components/ManagerCounter/ManagerCounter";
import DashboardPage from "../dashboard/DashboardPage";
import HooksPage from "../web-hook/HooksPage";
import FunctionPage from "../web-hook/FunctionPage";
import SchemaPage from "../schema/SchemaPage";
// import menu from "./menu";
import { menus } from "./menus";
import DashboardMain from "../DashboardMain/DashboardMain";
import TaskBoard from "../TaskBoard/TaskBoard";
import TimeManagement from "../EmployeeSelfService/TimeManagement/TimeManagement";
import Profile from "../MyProfile/Profile";
import Settings from "../settings/Settings";
import TrainingPage from "../EmployeeSelfService/Training/TrainingPage";
import LeaveManagementPage from "../EmployeeSelfService/LeaveManagement/LeaveManagementPage";
import AccomplishmentPage from "../MeritRewardRecognition/Accomplishments/AccomplishmentPage";
import CommendationPage from "../MeritRewardRecognition/Commendation/CommendationPage";
import NominationPage from "../MeritRewardRecognition/Nomination/NominationPage";
import SpecialAwardPage from "../MeritRewardRecognition/SpecialAward/SpecialAwardPage";
import TimesheetPage from "../HumanResource/TimeSheet/TimesheetPage";
import LeavePage from "../HumanResource/Leave/LeavePage";
import RegionsPage from "../OrganizationaStructure/regions/RegionsPage";
import OfficesPage from "../OrganizationaStructure/offices/OfficesPage";
import DivisionPage from "../OrganizationaStructure/divisions/DivisionPage";
import SectionsPage from "../OrganizationaStructure/sections/SectionsPage";
import UnitsPage from "../OrganizationaStructure/units/UnitsPage";
import ClustersPage from "../OrganizationaStructure/clusters/ClustersPage";
import DivisionFormPage from "../OrganizationaStructure/divisions/division-form/DivisionFormPage";
import SectionFormPage from "../OrganizationaStructure/sections/section-form/SectionFormPage";
import UnitFormPage from "../OrganizationaStructure/units/unit-form/UnitFormPage";
import ClusterFormPage from "../OrganizationaStructure/clusters/cluster-form/ClusterFormPage";
import OfficeFormPage from "../OrganizationaStructure/offices/office-form/OfficeFormPage";
import EmploymentTypePage from "../ReferenceTable/employment-type/EmploymentTypePage";
import ScheduleTemplatePage from "../ReferenceTable/schedule-template/ScheduleTemplatePage";
import TaxTablePage from "../ReferenceTable/tax-table/TaxTablePage";
import AllowanceTypePage from "../ReferenceTable/allowance-type/AllowanceTypePage";
import SalaryGradePage from "../ReferenceTable/salary-grade/SalaryGradePage";
import SalaryFormPage from "../ReferenceTable/salary-grade/salary-form/SalaryFormPage";
import GovernmentUnitPage from "../ReferenceTable/government-unit/GovernmentUnitPage";
import TaxFormPage from "../ReferenceTable/tax-table/tax-form/TaxFormPage";
import ContributionTypePage from "../ReferenceTable/contribution-type/ContributionTypePage";
import ScheduleFormPage from "../ReferenceTable/schedule-template/schedule/ScheduleFormPage";
import LeaveTypePage from "../ReferenceTable/leave-type/LeaveTypePage";
import ServiceRequestPage from "../ReferenceTable/service-request/ServiceRequestPage";
import EmployeesPage from "../HumanResource/Employees/EmployeesPage";
import EmployeeFormPage from "../HumanResource/Employees/employee-form/EmployeeFormPage";
import ContributionFormPage from "../ReferenceTable/contribution-type/contribution-form/ContributionFormPage";
import NoticesPage from "../HumanResource/Notices/NoticesPage";
import NoticesFormPage from "../HumanResource/Notices/notices-form/NoticesFormPage";
import PositionTitlePage from "../Recruitement/PositionTitles/PositionTitlePage";
import UsersPage from "../system-administration/users/UsersPage";
import UsersFormPage from "../system-administration/users/users-form/UsersFormPage";
import OverTimePage from "../EmployeeSelfService/Overtime/OverTimePage";
import EmOverTimePage from "../HumanResource/EmOvertime/EmOverTimePage";
import HolidayPage from "../HumanResource/Holidays/HolidayPage";
import HolidaysFormPage from "../HumanResource/Holidays/holiday-form/HolidaysFormPage";
import LibraryPage from "../HumanResource/Library/LibraryPage";
import PerformancePage from "../HumanResource/Performance/PerformancePage";
import HR_TrainingPage from "../HumanResource/HR-Trainings/HR_TrainingPage";
import Work_SuspensionPage from "../HumanResource/Work-suspension/Work_SuspensionPage";
import PayslipPage from "../EmployeeSelfService/Payslip/PayslipPage";
import OBRequestPage from "../EmployeeSelfService/OBRequest/OBRequestPage";
import OBRequestFormPage from "../EmployeeSelfService/OBRequest/ob-request-form/OBRequestFormPage";
import RequestPage from "../ServiceRequest/RequestPage";
import IPCRPage from "../MyPerformance/IPCR/IPCRPage";
import IPCRForm from "../MyPerformance/IPCR/ipcr-form/IPCRForm";
import OPCRPage from "../MyPerformance/OPCR/OPCRPage";
import OPCRForm from "../MyPerformance/OPCR/opcr-form/OPCRForm";
import DPCRPage from "../MyPerformance/DPCR/DPCRPage";
import DPCRForm from "../MyPerformance/DPCR/opcr-form/DPCRForm";
import JobPostingsPage from "../Recruitement/JobPostings/JobPostingsPage";
import JobPostingFormPage from "../Recruitement/JobPostings/jobPosting-form/JobPostingFormPage";
import JobApplicantsPage from "../Recruitement/JobApplicants/JobApplicantsPage";
import ListOfEmployeeForm from "../MeritRewardRecognition/Commendation/CommendationTable/ViewListOfEmployee/ListOfEmployeeForm";
import AccomplishmentEmployeeForm from "../MeritRewardRecognition/Accomplishments/AccomplishmentsTable/ViewListOfEmployee/AccomplishmentEmployeeForm";
import TrainingManagementPage from "../LearningManagement/Training/TrainingManagementPage";
import TrainingManagementReportPage from "../LearningManagement/TrainingReport/TrainingManagementReportPage";
import TrainingManagementSchedulePage from "../LearningManagement/TrainingSchedule/TrainingManagementSchedulePage";
import TraineesForm from "../LearningManagement/Training/TrainingTable/trainees-form/TraineesForm";
import ViewTrainingList from "../LearningManagement/Training/TrainingTable/training-list-form/ViewTrainingList";
import GeneratePayrollPage from "../Finance/GeneratePayroll/GeneratePayrollPage";
import PayrollListPage from "../Finance/PayrollList/PayrollListPage";
import AnnualTaxesPage from "../Finance/AnnualTaxes/AnnualTaxesPage";
import ContributionsPage from "../Finance/Contributions/ContributionsPage";
import DisbursementFormPage from "../Finance/Disbursements/DisbursementForm/DisbursementFormPage";
import DisbursementsPage from "../Finance/Disbursements/DisbursementsPage";
import BankAccPage from "../Finance/BankAccounts/BankAccPage";
import PositionTitleFormPage from "../Recruitement/PositionTitles/position-title-form/PositionTitleFormPage";
import WorkFlowBuilderPage from "../system-administration/work-flow-builder/WorkFlowBuilderPage";
import WorkFlowFormPage from "../system-administration/work-flow-builder/workflow-form/WorkFlowFormPage";
import HealthCheckPage from "../system-administration/health-check/HealthCheckPage";
import RolePermissionPage from "../system-administration/Role-Permission/RolePermissionPage";
import RolePermissionForm from "../system-administration/Role-Permission/role-permission-form/RolePermissionForm";
import PortalSettingsPage from "../system-administration/portal-settings/PortalSettingsPage";
import PortalSettingsFormPage from "../system-administration/portal-settings/portal-settings-form/PortalSettingsFormPage";
import BiometricLogsPage from "../system-administration/biometric-logs/BiometricLogsPage";
import AuditLogsPage from "../system-administration/audit-logs/AuditLogsPage";
import BatchJobsPage from "../system-administration/batch-jobs/BatchJobsPage";
import ManualTSheetsPage from "../system-administration/manual-timesheets/ManualTSheetsPage";
import ClonePermissionForm from "../system-administration/Role-Permission/clone-permission-form/ClonePermissionForm";
import ProtectedRoute from "./ProtectedRoute";
import NotAutorizePage from "./NotAutorizePage";
import OpenForNiminationForm from "../MeritRewardRecognition/Nomination/UserNominationTable/OpenForNiminationForm";
import UserAccomplishmentsForm from "../MeritRewardRecognition/Accomplishments/UserAccomplishmentsTable/UserAccomplishmentsForm";
import ViewNominationList from "../MeritRewardRecognition/Nomination/NominationTable/ViewNomination/ViewNominationList";
import ViewRolePermission from "../system-administration/Role-Permission/role-permission-form/ViewRolePermission";
import ViewUsersFormPage from "../system-administration/users/users-form/ViewUsersFormPage";
import TrainingAppearanceForm from "../LearningManagement/TrainingReport/training-report-table/view-certificate/training-appearance/TrainingAppearanceForm";
import TrainingCertificateForm from "../LearningManagement/TrainingReport/training-report-table/view-certificate/training-certificate/TrainingCertificateForm";
import LeaveTableFormPage from "../HumanResource/Leave/leaveTable/LeaveRequest/Leavereq-form/LeaveTableFormPage";
import MonetizationRequestForm from "../HumanResource/Leave/leaveTable/MonetizationRequests/Monetizationreq-form/MonetizationRequestForm";
import ServiceRequestView from "../ServiceRequest/service-request-form/ServiceRequestView";
import BiometricsPage from "../system-administration/biometric/BiometricsPage";
import OtherDeductionPage from "../ReferenceTable/OtherDeduction/OtherDeductionPage";
import OtherDeductionFormPage from "../ReferenceTable/OtherDeduction/other-deduction-form/OtherDeductionFormPage";
import IncentivePage from "../ReferenceTable/incentives/IncentivePage";
import IncentiveFormPage from "../ReferenceTable/incentives/incentive-form/IncentiveFormPage";
import PayrollTypePage from "../ReferenceTable/payroll-type/PayrollTypePage";
import PayrollTtypeFormPage from "../ReferenceTable/payroll-type/payroll-type-form/PayrollTtypeFormPage";
import PayrollTypeAssignPage from "../ReferenceTable/payroll-type-assign/PayrollTypeAssignPage";
import PayrollTypeAssignFormPage from "../ReferenceTable/payroll-type-assign/payroll-type-assign-form/PayrollTypeAssignFormPage";
import JobPostingViewPage from "../Recruitement/JobPostings/jobPosting-form/JobPostingViewPage";
import JobApplicantsView from "../Recruitement/JobApplicants/JobApplicantFrom/JobApplicantsView";
import ServiceRequestLogPage from "../RequestsLog/ServiceRequestLogPage";
import BiometricFacePage from "../biometric-face-capture/BiometricFacePage";
// import ViewPayrollForm from "../Finance/PayrollList/payrollForm/ViewPayrollForm";
import RecentActivities from "../DashboardMain/components/Notice/ViewActivities/RecentActivities";
import AllowanceFormPage from "../ReferenceTable/allowance-type/allowance-form/AllowanceFormPage";
import ViewIPCRForm from "../MyPerformance/IPCR/ipcr-form/ViewIPCRForm";
import ViewOPCRForm from "../MyPerformance/OPCR/opcr-form/ViewOPCRForm";
import ViewDPCRForm from "../MyPerformance/DPCR/opcr-form/ViewDPCRForm";
import PerformanceFormPage from "../HumanResource/Performance/PerformanceForm/PerformanceFormPage";
import PerformanceMyPage from "../Performance/PerformanceMyPage";
import SPCRForm from "../MyPerformance/SPCR/spcr-form/SPCRForm";
import ViewSPCRForm from "../MyPerformance/SPCR/spcr-form/ViewSPCRForm";
import SPCRPage from "../MyPerformance/SPCR/SPCRPage";
import CommitteeListPage from "../Committee/Committee-List/CommitteeListPage";
import DesignationPage from "../Committee/Designation/DesignationPage";
import ExecutiveDashboardPage from "../DashboardMain/ExecutiveDashboard/ExecutiveDashboardPage";
import NoticeTemplatePage from "../system-administration/notice-template/NoticeTemplatePage";
import NoticeTemplateFormPage from "../system-administration/notice-template/notice-template-from/NoticeTemplateFormPage";
import MedicalRecordPage from "../MedicalRecord/medical-record/MedicalRecordPage";
import MedicalRecordForm from "../MedicalRecord/medical-record/medical-record-form/MedicalRecordForm";
import ConsultationPage from "../MedicalRecord/consultation-page/ConsultationPage";
import ConsultationPageForm from "../MedicalRecord/consultation-page/consulation-form/ConsultationPageForm";
import DentalConsultationPageForm from "../MedicalRecord/dental-consultation-page/consulation-form/DentalConsultationPageForm";
import DentalConsultationPage from "../MedicalRecord/dental-consultation-page/DentalConsultationPage";
import ViewSalaryFormPage from "../ReferenceTable/salary-grade/salary-form/ViewSalaryFormPage";
import ViewTaxFormPage from "../ReferenceTable/tax-table/tax-form/ViewTaxFormPage";
import ViewNoticeTemplateFormPage from "../system-administration/notice-template/notice-template-from/ViewNoticeTemplateFormPage";
import GroupSchedulePage from "../ReferenceTable/group-schedule/GroupSchedulePage";
import GroupCollectionFormPage from "../ReferenceTable/group-schedule/grou-collection-form/GroupCollectionFormPage";
import LeaveApproverPage from "../HumanResource/HRMSApplicationLeave/LeaveApprover/LeaveApproverPage";
import LeaveApproverFormPage from "../HumanResource/HRMSApplicationLeave/LeaveApprover/leave-approver-form/LeaveApproverFormPage";
import HRMSApplication from "../HumanResource/HRMSApplicationLeave/HRMSApplication";
import HRDDApplication from "../HumanResource/HRDDForApproval/HRDDApplication";
import HrddForApprovalFormPage from "../HumanResource/HRDDForApproval/HRDDLeave/Hrdd-form-page/HrddForApprovalFormPage";
import MonetizationApproverForm from "../HumanResource/HRMSApplicationLeave/MonetizatrionApprover/Monetization-approver-form/MonetizationApproverForm";
import MonetizationHrddForm from "../HumanResource/HRDDForApproval/HRDDMonetization/Monetization-hrdd-form/MonetizationHrddForm";
import ViewGroupCollectionFormPage from "../ReferenceTable/group-schedule/grou-collection-form/ViewGroupCollectionFormPage";
import CommitteeFormPage from "../Committee/Committee-Form/CommitteeFormPage";
import ViewCommitteeFormPage from "../Committee/Committee-Form/ViewCommitteeFormPage";
import ProcessPayrollPage from "../Finance/Payroll/ProcessPayrollPage";
import { findObjectUseCase } from "../../usecases/object";
import NonPlantillaPage from "../ReferenceTable/non-plantilla/NonPlantillaPage";
import NatureOfFunctionsPage from "../ReferenceTable/nature-functions/NatureOfFunctionsPage";
import PayCodePage from "../ReferenceTable/pay-code/PayCodePage";
import PayrollCombinationPage from "../ReferenceTable/payroll-combination/PayrollCombinationPage";
import DTRAttachementPage from "../system-administration/DTRAttachments/DTRAttachementPage";
import DTRAttachementForm from "../system-administration/DTRAttachments/dtr-form/DTRAttachementForm";
import ViewDTRAttachementForm from "../system-administration/DTRAttachments/dtr-form/ViewDTRAttachementForm";
import AirportAssignPage from "../HumanResource/Airport-assign/AirportAssignPage";
import AccountsTitlePage from "../ReferenceTable/accounts-title/AccountsTitlePage";
import NonPlantillaFormPage from "../ReferenceTable/non-plantilla/non-plantilla-form/NonPlantillaFormPage";
import ReportPage from "../HumanResource/Reports/ReportPage";
import NatureOfFunctionsForm from "../ReferenceTable/nature-functions/nature-functions-form/NatureOfFunctionsForm";
import AirportAssignForm from "../HumanResource/Airport-assign/airport-form/AirportAssignForm";
import EmployeeEarningsPage from "../Finance/EmployeeEarnings/EmployeeEarningsPage";
import ViewPayrollFormPage from "../Finance/PayrollList/payrollForm/ViewPayrollFormPage";
import ScheduleReportPage from "../HumanResource/schedule-report/ScheduleReportPage";
import Progress from "../../components/Progress";
import PayrollLayoutsPage from "../ReferenceTable/payroll-layouts/PayrollLayoutsPage";
import PayrollLayoutsFormPage from "../ReferenceTable/payroll-layouts/layouts-form/PayrollLayoutsFormPage";
import PayrollSetupPage from "../ReferenceTable/payroll-setups/PayrollSetupPage";
import PayrollSetupsFormPage from "../ReferenceTable/payroll-setups/payroll-setups-form/PayrollSetupsFormPage";
import PayrollSetupsPage from "../Finance/Payrolls/PayrollSetupsPage";
import ItemOptionsPage from "../ReferenceTable/item-options/ItemOptionsPage";
import ItemOptionsFormPage from "../ReferenceTable/item-options/item-options-form/ItemOptionsFormPage";
import AccessPINPage from "../system-administration/AccessPinPage/AccessPINPage";
import OBForApprovalPage from "../HumanResource/OBApproval/OBForApprovalPage";
import LeaveCreditsPage from "../HumanResource/LeaveCredits/LeaveCreditsPage";
import LeaveCreditsFormPage from "../HumanResource/LeaveCredits/LeaveCreditsFormPage";
import OBManagementPage from "../Finance/OBManagement/OBManagementPage";
import PayslipAdminPage from "../Finance/Payslip/PayslipAdminPage";
import EmployeeRecordsPage from "../Finance/EmployeeRecords/EmployeeRecordsPage";
import EmployeeRecordsForm from "../Finance/EmployeeRecords/employee-records-form/EmployeeRecordsForm";
import NavBar from "../../components/navigation";
import DepartmentHeadPage from "../ReferenceTable/department-head/DepartmentHeadPage";
import DepartmentHeadForm from "../ReferenceTable/department-head/department-form/DepartmentHeadForm";

class MainPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new MainPagePresenter(
      this,
      getCurrentUserUseCase(),
      signOutUseCase(),
      getAllSchemasUseCase(),
    );
  }

  beforeUnloadHandler = (e) => {
    // Mark that we're navigating away
    sessionStorage.setItem("navigatingAway", Date.now().toString());
  };

  async componentDidMount() {
    const navigatingAway = sessionStorage.getItem("navigatingAway");

    if (navigatingAway) {
      const timeElapsed = Date.now() - parseInt(navigatingAway);

      // If less than 5 seconds elapsed, it's likely a refresh
      if (timeElapsed < 5000) {
        sessionStorage.removeItem("navigatingAway");
      } else {
        // More than 2 seconds = user closed and reopened
        localStorage.clear();
      }
    }

    await this.presenter.componentDidMount();
    // await this.setPermissions();
    this.startInactivityListener(); // add this

    window.addEventListener("beforeunload", this.beforeUnloadHandler);
  }
  // INACTIVITY_LIMIT = 1000 * 60 * 1000;
  INACTIVITY_LIMIT = 15 * 60 * 1000;

  inactivityTimer = null;

  componentWillUnmount() {
    this.cleanupInactivityListener();

    window.removeEventListener("beforeunload", this.beforeUnloadHandler);
  }

  requirePasswordReset() {
    this.setState({ mustResetPassword: true });
  }

  clearPasswordReset() {
    this.setState({ mustResetPassword: false });
  }

  startInactivityListener() {
    const events = [
      "mousemove",
      "mousedown",
      "keypress",
      "scroll",
      "touchstart",
    ];
    this.resetInactivityTimer = this.resetInactivityTimer.bind(this);
    events.forEach((event) =>
      window.addEventListener(event, this.resetInactivityTimer),
    );
    this.resetInactivityTimer();
  }

  resetInactivityTimer() {
    clearTimeout(this.inactivityTimer);
    this.inactivityTimer = setTimeout(() => {
      this.presenter.onInactivityLogout();
    }, this.INACTIVITY_LIMIT);
  }

  cleanupInactivityListener() {
    const events = [
      "mousemove",
      "mousedown",
      "keypress",
      "scroll",
      "touchstart",
    ];
    events.forEach((event) =>
      window.removeEventListener(event, this.resetInactivityTimer),
    );
    clearTimeout(this.inactivityTimer);
  }

  fields = ["region", "office", "division", "section", "unit"];
  orgFields = [
    "employee.region",
    "employee.office",
    "employee.division",
    "employee.section",
    "employee.unit",
  ];
  orgCollection = ["Region", "offices", "Division", "Sections", "Units"];

  getLastNonEmptyField = (source) => {
    let result = "";
    let index = -1;

    this.fields.forEach((field, i) => {
      if (source[field] && source[field] !== "") {
        result = source[field];
        index = i;
      }
    });

    return { result, index };
  };

  async setPermissions(permission, employee, division) {
    try {
      this.setState({
        position: employee.position?.position_title,
        division: division?.name || "",
        empName: `${employee.Firstname || ""} ${
          employee.Middlename || ""
        } ${employee.surname || ""}`,
      });
      if (permission?.length > 0) {
        this.setState({ permission });
      }
    } catch (error) {
      console.error("Error setting permissions:", error);
    }
  }

  onClickSignOut() {
    this.presenter.onClickSignOut();
  }

  onClickMenu(e, item) {
    e.preventDefault();
    if (this.state.mustResetPassword) return;
    this.navigateTo(item.route);
  }
  render() {
    const user = this.getCurrentUser();
    const user1 = {
      picture: "/BIR.png", // Assuming BIR.png is located in the images folder
      username: "username_here", // Add the username here
    };
    const schemas = this.getSchemas();

    // if (user === undefined || schemas === undefined) {
    //   return <Progress />;
    // }
    // const userRoles = [];

    // this.getCurrentRoles().map((item) => {
    //   if (item.rolePermission) {
    //     return item.rolePermission.forEach((item) => userRoles.push(item));
    //   } else {
    //     return [];
    //   }
    // });

    // const uniqueMenus = userRoles.filter(
    //   (menu, index, self) =>
    //     index === self.findIndex((m) => m.name === menu.name)
    // );

    // // console.warn("Roles: ", uniqueMenus);
    // const permission = uniqueMenus.length ? uniqueMenus : [];

    const { permission } = this.state;
    const resetModal = this.state.mustResetPassword ? (
      <ResetPasswordPage onComplete={this.clearPasswordReset.bind(this)} />
    ) : null;

    if (!permission || user === undefined || schemas === undefined) {
      return (
        <>
          <Progress />
          {resetModal}
        </>
      );
    }

    return (
      <Layout>
        {resetModal}
        <Layout.Context.Consumer>
          {(value) => (
            <OffCanvas onSetShow={value.setCollapse} show={value.collapsed}>
              <div className="offcanvas-body bg-primary" style={{ padding: 0 }}>
                <nav className="navbar-dark">
                  <div
                    className="bg-white"
                    style={{
                      padding: "20px 30px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        alignItems: "center",
                      }}
                    >
                      <LogoHolder
                        className="bg-primary"
                        width="60px"
                        height="50px"
                        textClassName="text-white"
                        logo={user1.picture}
                        name={user.username}
                      />
                      <div
                        style={{
                          display: "block",
                          paddingLeft: "10px",
                          height: "70px",
                          fontSize: "15px",
                        }}
                      >
                        <strong>HRIS</strong>
                        <br></br>
                        <strong>Bureau of Immigration</strong>
                        <p style={{ fontSize: "12px" }}>
                          Human Resource Information System
                        </p>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        height: "1px",
                        marginTop: "20px",
                        backgroundColor: "#d3d3d3",
                      }}
                    />

                    <div className="col-lg-10">
                      <div
                        className="text-primary mt-3"
                        style={{ fontSize: "15px" }}
                      >
                        <p className="mb-1">
                          {this.state.empName || user.username}
                        </p>
                        <p
                          className="mb-1"
                          style={{ fontSize: "12px", color: "grey" }}
                        >
                          {this.state.division || ""}
                        </p>
                        <span
                          className="d-inline-block text-center"
                          style={{
                            color: "#1890ff",
                            backgroundColor: "#e6f7ff",
                            borderRadius: "4px",
                            border: "1px solid",
                            borderColor: "#91d5ff",
                            width: "80%",
                            fontSize: "12px",
                          }}
                        >
                          {this.state.position || ""}
                        </span>
                      </div>
                    </div>
                    {/* <p className="text-primary mt-3">
                      {this.state.empName || user.username}
                      <p
                        style={{
                          fontSize: "12px",
                          color: "grey",
                        }}
                      >
                        {this.state.division ||
                          "Administrative and Finance Office Human Capital Management Division"}
                        <p
                          className="text-center"
                          style={{
                            color: "#1890ff",
                            backgroundColor: "#e6f7ff",
                            borderRadius: "4px",
                            border: "1px solid",
                            borderColor: "#91d5ff",
                            width: "80%",
                          }}
                        >
                          {this.state.position ||
                            "Supervising Administrative Officer"}
                        </p>
                      </p>
                    </p> */}
                  </div>
                  <div
                    style={{
                      // padding: "10px 20px",
                      fontSize: "13px",
                      fontWeight: "normal",
                    }}
                  >
                    <Menu
                      onClickItem={this.onClickMenu.bind(this)}
                      // menus={this.filterAccess(menus, roles)}
                      menus={permission}
                      logout={this.onClickSignOut.bind(this)}
                      navigateTo={() => this.navigateTo("/signin")}
                    />
                  </div>
                </nav>
              </div>
            </OffCanvas>
          )}
        </Layout.Context.Consumer>
        <main
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <NavBar />
          <Routes>
            <Route path="/not-authorized" element={<NotAutorizePage />} />
            <Route exact path={"/"} element={<DashboardMain />} />
            {/*<Route*/}
            {/*  exact*/}
            {/*  path={"/collection/dashboard"}*/}
            {/*  element={<DashboardPage />}*/}
            {/*/>*/}
            <Route
              exact
              path={"/collection/:name"}
              element={<CollectionListPage />}
            />
            <Route path={"/collection/roles/form"} element={<RoleFormPage />} />
            <Route
              path={"/collection/roles/form/:id"}
              element={<RoleFormPage />}
            />
            <Route
              path={"/collection/:name/form/"}
              element={<CollectionFormPage />}
            />
            <Route
              path={"/collection/:name/form/:id"}
              element={<CollectionFormPage />}
            />
            <Route path={"/migration"} element={<MigrationPage />} />
            <Route path={"/schema"} element={<SchemaPage />} />
            <Route path={"/account"} element={<AccountPage />} />
            <Route path={"/hooks"} element={<HooksPage />} />
            <Route path={"/function"} element={<FunctionPage />} />

            {/* dashboard */}
            <Route
              path={"/dashboard"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={DashboardMain}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/executive_dashboard"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={ExecutiveDashboardPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/taskboard"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={TaskBoard}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/request"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={ServiceRequestLogPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/profile"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={Profile}
                  permissions={permission}
                />
              }
            />
            <Route path={"/profile/:id"} element={<Profile />} />

            <Route
              path={"/settings"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={Settings}
                  permissions={permission}
                />
              }
            />

            {/* organizational  */}
            <Route
              path={"/regions"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={RegionsPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/offices"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={OfficesPage}
                  permissions={permission}
                />
              }
            />
            <Route path={"/form/offices"} element={<OfficeFormPage />} />
            <Route path={"/form/offices/:id"} element={<OfficeFormPage />} />
            <Route
              path={"/divisions"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={DivisionPage}
                  permissions={permission}
                />
              }
            />
            <Route path={"/form/Division"} element={<DivisionFormPage />} />
            <Route path={"/form/Division/:id"} element={<DivisionFormPage />} />
            <Route
              path={"/sections"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={SectionsPage}
                  permissions={permission}
                />
              }
            />
            <Route path={"/form/sections"} element={<SectionFormPage />} />
            <Route path={"/form/sections/:id"} element={<SectionFormPage />} />
            <Route
              path={"/units"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={UnitsPage}
                  permissions={permission}
                />
              }
            />
            <Route path={"/form/Units"} element={<UnitFormPage />} />
            <Route path={"/form/Units/:id"} element={<UnitFormPage />} />
            <Route
              path={"/clusters"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={ClustersPage}
                  permissions={permission}
                />
              }
            />
            <Route path={"/form/Clusters"} element={<ClusterFormPage />} />
            <Route path={"/form/Clusters/:id"} element={<ClusterFormPage />} />

            {/* Training Management and Development  */}
            <Route
              path={"/learning/training"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={TrainingManagementPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/learning/training_report"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={TrainingManagementReportPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/learning/training_schedule"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={TrainingManagementSchedulePage}
                  permissions={permission}
                />
              }
            />

            <Route path={"/lern/employees/:id"} element={<TraineesForm />} />
            <Route
              path={"/list/management_training/:id"}
              element={<ViewTrainingList />}
            />
            <Route
              path={"/appearance/management_training/:id"}
              element={<TrainingAppearanceForm />}
            />
            <Route
              path={"/training/management_training/:id"}
              element={<TrainingCertificateForm />}
            />

            {/*Employee Self Service*/}
            <Route
              path={"/tmanagement"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={TimeManagement}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/lmanagement"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={LeaveManagementPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/form/leave_request/:id"}
              element={<LeaveTableFormPage />}
            />
            <Route
              path={"/form/monetization_request/:id"}
              element={<MonetizationRequestForm />}
            />
            <Route
              path={"/training"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={TrainingPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/overtime"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={OverTimePage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/payslip"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={PayslipPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/ob_requests"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={OBRequestPage}
                  permissions={permission}
                />
              }
            />
            <Route path={"/form/ob_requests"} element={<OBRequestFormPage />} />
            <Route
              path={"/form/ob_requests/:id"}
              element={<OBRequestFormPage />}
            />
            {/* Service Request  */}
            <Route
              path={"/service"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={RequestPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/view/requests/:id"}
              element={<ServiceRequestView />}
            />

            {/* My Performance  */}
            <Route
              path={"/ipcr"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={IPCRPage}
                  permissions={permission}
                />
              }
            />
            <Route path={"/form/ipcr"} element={<IPCRForm />} />
            <Route path={"/form/ipcr/:id"} element={<IPCRForm />} />
            <Route path={"/view/ipcr/:id"} element={<ViewIPCRForm />} />
            <Route
              path={"/opcr"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={OPCRPage}
                  permissions={permission}
                />
              }
            />
            <Route path={"/form/opcr"} element={<OPCRForm />} />
            <Route path={"/form/opcr/:id"} element={<OPCRForm />} />
            <Route path={"/view/opcr/:id"} element={<ViewOPCRForm />} />
            <Route
              path={"/dpcr"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={DPCRPage}
                  permissions={permission}
                />
              }
            />
            <Route path={"/form/dpcr"} element={<DPCRForm />} />
            <Route path={"/form/dpcr/:id"} element={<DPCRForm />} />
            <Route path={"/view/dpcr/:id"} element={<ViewDPCRForm />} />
            <Route
              path={"/spcr"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={SPCRPage}
                  permissions={permission}
                />
              }
            />
            <Route path={"/form/spcr"} element={<SPCRForm />} />
            <Route path={"/form/spcr/:id"} element={<SPCRForm />} />
            <Route path={"/view/spcr/:id"} element={<ViewSPCRForm />} />

            {/*Merit Reward and Recognition*/}
            <Route
              path={"/specialaward"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={SpecialAwardPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/form/special_award/:id"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={SpecialAwardPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/specialaward"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={SpecialAwardPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/commendation"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={CommendationPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/nomination"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={NominationPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/form/open_for_nomination/:id"}
              element={<OpenForNiminationForm />}
            />
            <Route
              path={"/accomplishments"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={AccomplishmentPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/form/accomplishment"}
              element={<UserAccomplishmentsForm />}
            />
            <Route
              path={"/comm/employees/:id"}
              element={<ListOfEmployeeForm />}
            />
            <Route
              path={"/form/nomination_list/:id"}
              element={<ViewNominationList />}
            />
            <Route
              path={"/acc/employees/:id"}
              element={<AccomplishmentEmployeeForm />}
            />

            {/*Human Resource*/}
            <Route
              path={"/employee"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={EmployeesPage}
                  permissions={permission}
                />
              }
            />
            <Route path={"form/employees"} element={<EmployeeFormPage />} />
            <Route path={"form/employees/:id"} element={<EmployeeFormPage />} />
            {/* <Route
              path={"profile/employees/:id"}
              element={<ProfileEmployeeFormPage />}
            /> */}
            {/* <Route
              path={"/report_list"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={ReportsPageNew}
                  permissions={permission}
                />
                // <ReportsPage />
              }
            /> */}
            <Route
              path={"/report_list"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={ReportPage}
                  permissions={permission}
                />
                // <ReportsPage />
              }
            />
            <Route
              path={"/overtimes"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={EmOverTimePage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/performance"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={PerformancePage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"form/performance/:id"}
              element={<PerformanceFormPage />}
            />
            <Route
              path={"/hr/trainings"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={HR_TrainingPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/holidays"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={HolidayPage}
                  permissions={permission}
                />
              }
            />
            <Route path={"form/holidays"} element={<HolidaysFormPage />} />
            <Route path={"form/holidays/:id"} element={<HolidaysFormPage />} />
            <Route
              path={"/library"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={LibraryPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/timesheet"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={TimesheetPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/leaves"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={LeavePage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/suspension"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={Work_SuspensionPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/hrms_for_leave"}
              element={
                <HRMSApplication //-> use this if The Routing restriction required!
                  element={LeaveApproverPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/approve/leave_request/:id"}
              element={<LeaveApproverFormPage />}
            />
            <Route
              path={"/approve/monetization_request/:id"}
              element={<MonetizationApproverForm />}
            />

            <Route
              path={"/hrdd_for_approval"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={HRDDApplication}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/airport_assign"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={AirportAssignPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"form/airport_assign"}
              element={<AirportAssignForm />}
            />
            <Route
              path={"form/airport_assign/:id"}
              element={<AirportAssignForm />}
            />

            <Route
              path={"/schedule_report"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={ScheduleReportPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/leave/leave_request/:id"}
              element={<HrddForApprovalFormPage />}
            />
            <Route
              path={"/leave/monetization_request/:id"}
              element={<MonetizationHrddForm />}
            />
            {/* // */}
            <Route
              path={"/medical_record"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={MedicalRecordPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/form/medical_record"}
              element={<MedicalRecordForm />}
            />
            <Route
              path={"/form/medical_record/:id"}
              element={<MedicalRecordForm />}
            />
            <Route
              path={"/view/medical_record/:id"}
              element={<MedicalRecordForm />}
            />

            <Route
              path={"/consultation"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={ConsultationPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/form/consultation"}
              element={<ConsultationPageForm />}
            />
            <Route
              path={"/form/consultation/:id"}
              element={<ConsultationPageForm />}
            />
            <Route
              path={"/view/consultation/:id"}
              element={<ConsultationPageForm />}
            />
            <Route
              path={"/dental_consultation"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={DentalConsultationPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/form/dental_consultation"}
              element={<DentalConsultationPageForm />}
            />
            <Route
              path={"/form/dental_consultation/:id"}
              element={<DentalConsultationPageForm />}
            />

            <Route
              path={"/ob_requests_approval"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={OBForApprovalPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/leave_credits"}
              element={
                <ProtectedRoute
                  element={LeaveCreditsPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/leave_credits/:id"}
              element={<LeaveCreditsFormPage />}
            />

            {/* Finance  */}

            <Route
              path={"/generate_payroll"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={GeneratePayrollPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/emp/payroll_list/:id"}
              element={<ViewPayrollFormPage />}
            />
            <Route
              path={"/payroll_list"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={PayrollListPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/annual_taxes"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={AnnualTaxesPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/contributions"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={ContributionsPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/disbursement"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={DisbursementsPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/form/disbursement"}
              element={<DisbursementFormPage />}
            />

            <Route
              path={"/form/disbursement/:id"}
              element={<DisbursementFormPage />}
            />

            <Route
              path={"/bank_account"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={BankAccPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/payroll"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={ProcessPayrollPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/new_payroll"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={PayrollSetupsPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/employees"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={EmployeeEarningsPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/ob_management"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={OBManagementPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/payslip_admin"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={PayslipAdminPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/employee_records"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={EmployeeRecordsPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"form/employee_records/:id"}
              element={<EmployeeRecordsForm />}
            />
            <Route
              path={"view/employee_records/:id"}
              element={<EmployeeRecordsForm />}
            />
            {/*RECRUITEMENT*/}
            <Route
              path={"/position_titles"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={PositionTitlePage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/form/position_titles"}
              element={<PositionTitleFormPage />}
            />
            <Route
              path={"/form/position_titles/:id"}
              element={<PositionTitleFormPage />}
            />
            <Route
              path={"/view/position_titles/:id"}
              element={<PositionTitleFormPage />}
            />
            <Route
              path={"/job_postings"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={JobPostingsPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/form/job_postings"}
              element={<JobPostingFormPage />}
            />
            <Route
              path={"/form/job_postings/:id"}
              element={<JobPostingFormPage />}
            />
            <Route
              path={"/view/job_postings/:id"}
              element={<JobPostingViewPage />}
            />

            <Route
              path={"/job_applicants"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={JobApplicantsPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/view/job_applicants/:id"}
              element={<JobApplicantsView />}
            />

            {/* System Administration  */}
            <Route
              path={"/users"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={UsersPage}
                  permissions={permission}
                />
              }
            />
            <Route path={"/form/users"} element={<UsersFormPage />} />
            <Route path={"/form/users/:id"} element={<UsersFormPage />} />
            <Route path={"/view/users/:id"} element={<ViewUsersFormPage />} />

            <Route
              path={"/workflows"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={WorkFlowBuilderPage}
                  permissions={permission}
                />
              }
            />
            <Route path={"/form/work_flows"} element={<WorkFlowFormPage />} />
            <Route
              path={"/form/work_flows/:id"}
              element={<WorkFlowFormPage />}
            />
            <Route
              path={"/ad-health"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={HealthCheckPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/roles"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={RolePermissionPage}
                  permissions={permission}
                />
              }
            />
            <Route path={"/form/roles"} element={<RolePermissionForm />} />
            <Route path={"/form/roles/:id"} element={<RolePermissionForm />} />
            <Route path={"/view/roles/:id"} element={<ViewRolePermission />} />
            <Route
              path={"/clone/roles/:id"}
              element={<ClonePermissionForm />}
            />
            <Route
              path={"/admin/portal-settings"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={PortalSettingsPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/form/portal_settings"}
              element={<PortalSettingsFormPage />}
            />
            <Route
              path={"/form/portal_settings/:id"}
              element={<PortalSettingsFormPage />}
            />
            <Route
              path={"/biometric_logs"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={BiometricLogsPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/manual_dtr"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={DTRAttachementPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/access_pin"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={AccessPINPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"form/manual_dtr/:id"}
              element={<DTRAttachementForm />}
            />
            <Route path={"form/manual_dtr"} element={<DTRAttachementForm />} />
            <Route
              path={"view/manual_dtr/:id"}
              element={<ViewDTRAttachementForm />}
            />
            <Route
              path={"/biometric_face"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={BiometricFacePage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/biometrics"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={BiometricsPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/audit_logs"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={AuditLogsPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/batch_jobs"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={BatchJobsPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/manual_timesheets"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={ManualTSheetsPage}
                  permissions={permission}
                />
              }
            />

            {/*Reference Table*/}
            <Route
              path={"/employment"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={EmploymentTypePage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/other_deductions"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={OtherDeductionPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"form/other_deductions"}
              element={<OtherDeductionFormPage />}
            />
            <Route
              path={"form/other_deductions/:id"}
              element={<OtherDeductionFormPage />}
            />

            <Route
              path={"/incentive"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={IncentivePage}
                  permissions={permission}
                />
              }
            />
            <Route path={"form/incentive"} element={<IncentiveFormPage />} />
            <Route
              path={"form/incentive/:id"}
              element={<IncentiveFormPage />}
            />
            <Route
              path={"/payroll_type"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={PayrollTypePage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"form/payroll_type"}
              element={<PayrollTtypeFormPage />}
            />
            <Route
              path={"form/payroll_type/:id"}
              element={<PayrollTtypeFormPage />}
            />

            <Route
              path={"/payroll_type_assign"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={PayrollTypeAssignPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"form/payroll_type_assign"}
              element={<PayrollTypeAssignFormPage />}
            />
            <Route
              path={"form/payroll_type_assign/:id"}
              element={<PayrollTypeAssignFormPage />}
            />
            <Route
              path={"/schedule"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={ScheduleTemplatePage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/form/schedule_template"}
              element={<ScheduleFormPage />}
            />
            <Route
              path={"/form/schedule_template/:id"}
              element={<ScheduleFormPage />}
            />
            <Route
              path={"/view/schedule_template/:id"}
              element={<ScheduleFormPage />}
            />
            <Route
              path={"/tax"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={TaxTablePage}
                  permissions={permission}
                />
              }
            />
            <Route path={"/form/tax-table"} element={<TaxFormPage />} />
            <Route path={"/form/tax-table/:id"} element={<TaxFormPage />} />
            <Route path={"/view/tax-table/:id"} element={<ViewTaxFormPage />} />

            <Route
              path={"/leavetype"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={LeaveTypePage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/service_request"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={ServiceRequestPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/government_unit"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={GovernmentUnitPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/group_schedule"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={GroupSchedulePage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/non_plantilla"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={NonPlantillaPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/form/non_plantilla"}
              element={<NonPlantillaFormPage />}
            />
            <Route
              path={"/form/non_plantilla/:id"}
              element={<NonPlantillaFormPage />}
            />
            <Route
              path={"/nature_functions"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={NatureOfFunctionsPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"form/nature_functions"}
              element={<NatureOfFunctionsForm />}
            />
            <Route
              path={"form/nature_functions/:id"}
              element={<NatureOfFunctionsForm />}
            />
            <Route
              path={"/accounts_title"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={AccountsTitlePage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/pay_code"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={PayCodePage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/payroll_combination"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={PayrollCombinationPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/form/group_schedule/:id"}
              element={<GroupCollectionFormPage />}
            />
            <Route
              path={"/view/group_schedule/:id"}
              element={<ViewGroupCollectionFormPage />}
            />
            <Route
              path={"/form/group_schedule"}
              element={<GroupCollectionFormPage />}
            />
            <Route
              path={"/allowance_type"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={AllowanceTypePage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/form/allowance_type"}
              element={<AllowanceFormPage />}
            />
            <Route
              path={"/form/allowance_type/:id"}
              element={<AllowanceFormPage />}
            />
            <Route
              path={"/contribution_type"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={ContributionTypePage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"form/contribution_type"}
              element={<ContributionFormPage />}
            />
            <Route
              path={"form/contribution_type/:id"}
              element={<ContributionFormPage />}
            />
            <Route
              path={"/salary_grade"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={SalaryGradePage}
                  permissions={permission}
                />
              }
            />
            <Route path={"/form/salary_grade"} element={<SalaryFormPage />} />
            <Route
              path={"/form/salary_grade/:id"}
              element={<SalaryFormPage />}
            />
            <Route
              path={"/view/salary_grade/:id"}
              element={<ViewSalaryFormPage />}
            />

            <Route
              path={"/payroll_layouts"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={PayrollLayoutsPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/form/payroll_layouts"}
              element={<PayrollLayoutsFormPage />}
            />
            <Route
              path={"/form/payroll_layouts/:id"}
              element={<PayrollLayoutsFormPage />}
            />

            <Route
              path={"/department_head"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={DepartmentHeadPage}
                  permissions={permission}
                />
              }
            />
            <Route
              path={"/form/department_head"}
              element={<DepartmentHeadForm />}
            />
            <Route
              path={"/form/department_head/:id"}
              element={<DepartmentHeadForm />}
            />

            <Route
              path={"/payroll_setups"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={PayrollSetupPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/form/payroll_setups"}
              element={<PayrollSetupsFormPage />}
            />
            <Route
              path={"/form/payroll_setups/:id"}
              element={<PayrollSetupsFormPage />}
            />

            <Route
              path={"/item_options"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={ItemOptionsPage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/form/item_options"}
              element={<ItemOptionsFormPage />}
            />
            <Route
              path={"/form/item_options/:id"}
              element={<ItemOptionsFormPage />}
            />

            <Route
              path={"/notice_templates"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={NoticeTemplatePage}
                  permissions={permission}
                />
              }
            />

            <Route
              path={"/form/notice_templates"}
              element={<NoticeTemplateFormPage />}
            />

            <Route
              path={"/form/notice_templates/:id"}
              element={<NoticeTemplateFormPage />}
            />
            <Route
              path={"/view/notice_templates/:id"}
              element={<ViewNoticeTemplateFormPage />}
            />

            <Route
              path={"/notices"}
              element={
                <ProtectedRoute //-> use this if The Routing restriction required!
                  element={NoticesPage}
                  permissions={permission}
                />
              }
            />
            <Route path={"/form/notices"} element={<NoticesFormPage />} />
            <Route path={"/view/notices/:id"} element={<NoticesFormPage />} />
            <Route path={"/form/notices/:id"} element={<NoticesFormPage />} />
            <Route path={"/my-performance"} element={<PerformanceMyPage />} />
            {/* <Route path={"/notices"} element={<NoticesPage />} /> */}

            <Route path={"/app/activities"} element={<RecentActivities />} />
            <Route path={"/committee"} element={<CommitteeListPage />} />
            <Route path={"form/committee"} element={<CommitteeFormPage />} />
            <Route
              path={"form/committee/:id"}
              element={<CommitteeFormPage />}
            />
            {/* <Route path={"/form/committee/"} element={<CommitteeListPage />} /> */}
            <Route
              path={"/view/committee/:id"}
              element={<ViewCommitteeFormPage />}
            />
            <Route
              exact
              path={"/committeee_category"}
              element={<DesignationPage />}
            />
            <Route element={<NotFoundPage />} />
          </Routes>
          <footer
            className="bg-dark text-white text-center py-4"
            style={{
              marginTop: "auto",
              width: "100%",
            }}
          >
            <div className="container">
              <div className="footer-content">
                <a
                  style={{
                    color: "white ",
                    borderBottom: "1px solid #fff",
                  }}
                  href="https://www.google.com/maps/dir//Bureau+of+Immigration+Head+Office+HXVG%2BR53+Magallanes+Dr+Intramuros,+Manila,+1002+Metro+Manila/@14.5945248,120.9754254,17z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3397ca17691abc91:0xb7622582aa396dce!2m2!1d120.9754254!2d14.5945248?entry=ttu"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Magallanes Drive, Intramuros, Manila, Philippines 1002 <br />
                </a>
                Direct Line: (+632) 8-524-3769, Trunk Line Number (+632)
                8-465-2400
                <br />
                <a
                  style={{
                    color: "white",
                    borderBottom: "1px solid #fff",
                  }}
                  href="https://immigration.gov.ph"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Bureau of Immigration
                </a>{" "}
                | immigPH@gmail.com | binoc_immigration@hotmail.ph <br />
                Copyright © {new Date().getFullYear()}. All Rights Reserved.
              </div>
            </div>
          </footer>
        </main>
      </Layout>
    );
  }
}

export default withRouter(MainPage);
